const locale = {
    placeholder: 'Válasszon időt',
};
export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/hu_HU.tsx